




















































































































/* eslint-disable max-len */
import {
  defineComponent, reactive, toRefs, onBeforeMount, computed, ComputedRef,
} from '@vue/composition-api'
/* import Pod from '@/components/layouts/Pod.vue'
import PodCard from '@/components/layouts/PodCard.vue'
 */// import { getHumanDateFromUnixTimestamp } from '@/lib/utils/getHumanDateFromUnixTimeStamp'
import { compareObjectsByKeyValue } from '@/lib/utils/sort/compareObjectsByKeyValue'
import SessionView from './SessionView.vue'

/**
 * Shape of the data, that we get from vuex store.
 * TODO: put this definition somewhere in the store.
 */
interface RemoteSessionData {
  date: string;
  clientId: string;
  therapistId: string;
  note?: string;
  localReference?: string;
}

type LocalSessionData = RemoteSessionData & {
  dateObj: Date;
  id: string;
}

interface Sessions {
  data: {[key: string]: RemoteSessionData};
}

type State = {
  loading: boolean;
  editToggle: boolean;
}

const initialState: State = {
  loading: true,
  editToggle: false,
}

export default defineComponent({
  components: {
    SessionView, // Pod, PodCard,
  },
  props: {
    clientId: { type: String, default: '' },
    clientName: { type: String, default: '' },
  },

  setup(props, context) {
    // Set up state
    const state = reactive({ ...initialState })

    /** reactive get client from store */
    const sessions: ComputedRef<RemoteSessionData[]> = computed(() => {
      const sesss: LocalSessionData[] = []
      // Firestore will return an object with the client id's as keys
      // We will convert it into an array of client objects with the key as 'id' property
      const sessObj = context.root.$store.getters['clientSessions/all']
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(sessObj as [RemoteSessionData])) {
        sesss.push({
          id: key,
          ...value,
          clientId: props.clientId,
          dateObj: new Date(value.date),
        })
      }
      // console.log(sesss)
      return sesss.sort(compareObjectsByKeyValue({ key: 'dateObj' as keyof LocalSessionData, desc: true, type: 'date' }))
    })

    /**
     * Wire the component to our vuex implementation, e.g. get the client
     * If the client is undefined, open a new channel (this is specific to
     * the vuex/firebase lib that we are using)
     * TODO: implement error handling, i.e. no access to firebase.
     */
    onBeforeMount(() => {
      // console.log('beforemout')
      // we need to clear out state before opening for a new client..
      // https://mesqueeb.github.io/vuex-easy-firestore/extra-features.html#variables-for-firestorepath-or-filters
      // todo: implement a clientId in the state and check if its new, before clearing out state
      context.root.$store.dispatch('clientSessions/closeDBChannel', { clearModule: true })
      try {
        context.root.$store.dispatch('clientSessions/openDBChannel', { pathVariables: { clientId: props.clientId } })
          .then(() => {
            state.loading = false
          })
      } catch (e) {
        state.loading = false
        // console.log('some error')
        // console.log(e)
        // TODO:  check the error. It might just be that the dbchanell is already open
      }
    })

    // Make stuff available for the template
    return {
      // from self
      ...toRefs(state),
      sessions,

    }
  },
})

